import React from "react";
import { Dropdown } from "react-bootstrap";
import styles from "./Header.module.css";
import Avatar from "../Avatar";
import useWrapper from "../../hooks/useWrapper";
import useAuth from "../../hooks/useAuth";
import Breadcrumb from "../Breadcrumb";

export default function Header({ fullNav, controllerMenu, menu }) {
  const { breadcrumb, me } = useWrapper();
  const { signOut } = useAuth();
  return (
    <div className={`${styles.Header} -hide-on-print`}>
      <div className="d-flex">
        {me?.type === "Gestor" && (
          <div className={`${styles.Breadcrumb} ml-4`}>
            <Breadcrumb breadcrumb={breadcrumb} />
          </div>
        )}
      </div>
      {!!me?.type && (
        <div className={styles.Profile}>
          <Dropdown className="ml-3">
            <Dropdown.Toggle id="dropdown-options">
              <Avatar className="mr-2" username={me?.name || ""} />
              <div className={styles.profileNames}>
                <strong>{me?.name}</strong>
                <p>
                  {me?.sector ||
                    `${me?.commercials?.course?.title} ${me?.commercials?.institution?.title} ${me?.commercials?.year}.${me?.commercials?.period}`}
                </p>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => {
                  signOut();
                }}
              >
                Sair
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
    </div>
  );
}
